/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Footer_Section_LegalInputs */

const en_footer_section_legal = /** @type {(inputs: Footer_Section_LegalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Legal`)
};

const es_footer_section_legal = /** @type {(inputs: Footer_Section_LegalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Legal`)
};

const fr_footer_section_legal = /** @type {(inputs: Footer_Section_LegalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Légal`)
};

const de_footer_section_legal = /** @type {(inputs: Footer_Section_LegalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rechtliches`)
};

const ja_footer_section_legal = /** @type {(inputs: Footer_Section_LegalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`法的情報`)
};

const zh_footer_section_legal = /** @type {(inputs: Footer_Section_LegalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`法律条款`)
};

const ar_footer_section_legal = /** @type {(inputs: Footer_Section_LegalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`قانوني`)
};

const id_footer_section_legal = /** @type {(inputs: Footer_Section_LegalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hukum`)
};

const it_footer_section_legal = /** @type {(inputs: Footer_Section_LegalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Note Legali`)
};

const ru_footer_section_legal = /** @type {(inputs: Footer_Section_LegalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Юридическая информация`)
};

const pt_footer_section_legal = /** @type {(inputs: Footer_Section_LegalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Legal`)
};

const ko_footer_section_legal = /** @type {(inputs: Footer_Section_LegalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`법적 고지`)
};

/**
* | output |
* | --- |
* | "Legal" |
*
* @param {Footer_Section_LegalInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const footer_section_legal = /** @type {((inputs?: Footer_Section_LegalInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Footer_Section_LegalInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_footer_section_legal(inputs)
	if (locale === "es") return es_footer_section_legal(inputs)
	if (locale === "fr") return fr_footer_section_legal(inputs)
	if (locale === "de") return de_footer_section_legal(inputs)
	if (locale === "ja") return ja_footer_section_legal(inputs)
	if (locale === "zh") return zh_footer_section_legal(inputs)
	if (locale === "ar") return ar_footer_section_legal(inputs)
	if (locale === "id") return id_footer_section_legal(inputs)
	if (locale === "it") return it_footer_section_legal(inputs)
	if (locale === "ru") return ru_footer_section_legal(inputs)
	if (locale === "pt") return pt_footer_section_legal(inputs)
	return ko_footer_section_legal(inputs)
});